import { notification } from 'antd';
import { useMutation } from 'react-query';
import {
  bankConciliationReadTransactions,
  conciliate,
} from './BankConciliation.service';
import notificationError from '@/utils/functions/notificationError';

export function useBankConciliationReadTransactions() {
  return useMutation(bankConciliationReadTransactions, {
    async onSuccess() {
      notification.success({ message: 'Arquivo lido com sucesso' });
    },

    mutationKey: ['read-transactions'],

    onError(err) {
      notificationError(err);
    },
  });
}

export function useBankConciliationConciliate() {
  return useMutation(conciliate, {
    async onSuccess() {
      notification.success({
        message: 'Conciliação feita com sucesso!',
        description:
          'Todas as parcelas vinculadas as transações foram liquidadas, ' +
          'e criados os seus respectivos lançamentos bancários',
        duration: 20,
      });
    },

    onError(err) {
      notificationError(err);
    },
  });
}
